import React from 'react';

import { CustomOfferFormValues } from '@/typings/formValues';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';

import { Checkbox, FormControlLabel } from '@mui/material';

import CustomOfferBusinessTravellerMerchantFeeField from './CustomOfferBusinessTravellerMerchantFeeField';
import { customOfferMerchantFeeFieldLabel } from './customOfferMerchantFeeFieldLabel';

type Props = {
  isBusinessTraveller: boolean;
  userId: string;
  offerId?: string;
  control: Control<CustomOfferFormValues>;
  setValue: UseFormSetValue<CustomOfferFormValues>;
  hasOrders?: boolean;
  isSubmitting: boolean;
};

export default function CustomOfferMerchantFeeField({
  isBusinessTraveller,
  userId,
  offerId,
  control,
  setValue,
  hasOrders,
  isSubmitting,
}: Props) {
  if (isBusinessTraveller) {
    return (
      <CustomOfferBusinessTravellerMerchantFeeField
        userId={userId}
        offerId={offerId}
        control={control}
        setValue={setValue}
        hasOrders={hasOrders}
        isSubmitting={isSubmitting}
      />
    );
  }

  return (
    <Controller
      name="payment_metadata.merchant_fee_enabled"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          sx={{ alignItems: 'flex-start', m: 0 }}
          control={
            <Checkbox
              checked={field.value ?? true}
              onChange={(e) => field.onChange(e.target.checked)}
              onBlur={field.onBlur}
              name={field.name}
              inputRef={field.ref}
              disabled={isSubmitting}
              data-testid="merchant-fee-enabled"
            />
          }
          label={customOfferMerchantFeeFieldLabel}
        />
      )}
    />
  );
}
